<ion-header>
  <ion-toolbar>
    <ion-title>Confirm Your Email</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Illustration -->
  <div class="illustration">
    <img src="assets/img/group.svg" alt="Confirm Your Email" width="228px" height="159.71px">
  </div>

  <!-- Title & subtitle -->
  <div class="text-center">
    <h2>Confirm your email</h2>
    <p style="white-space: pre-line;">
      {{displayEmail}}
    </p>
  </div>

  <!-- Code input area -->


  <ion-card-content>

    <form>
      <div slot="label">
        Email <ion-text color="danger">*</ion-text>
        <ion-item class="custom-input">
          <ion-input type="text" inputmode="email" (ionInput)="onEmailInput($event)"
            (keydown.enter)="submit($event)">
          </ion-input>
        </ion-item>
      </div>
      <ion-button class="ion-margin" (click)="submit($event)" expand="block">
        Confirm
      </ion-button>

      <ion-button class="ion-margin" (click)="close()" expand="block" fill="clear">
        Close
      </ion-button>
    </form>

    <!--<div class="code-inputs">
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
        <ion-input maxlength="1" type="text" inputmode="numeric"></ion-input>
      </div> -->

    <!--  <p class="small-text">
        Didn’t get a code? <a href="#">Resend the code</a>
      </p>
      <p class="small-text">
        <a href="#">Contact us</a>
      </p> -->
  </ion-card-content>
</ion-content>